interface IBadgeProps {
  iconClass: string;
  condition: boolean | null;
  title?: string;
  badgeName?: string;
}

const Badge = ({ condition, iconClass, title, badgeName }: IBadgeProps) => {
  return (
    <span
      title={badgeName}
      className={`badge rounded-pill ${condition !== null ? (condition ? 'bg-success' : 'bg-danger') : 'bg-warning'}`}
    >
      <i className={`${iconClass} fs-6 p-1`}></i>
      {title && title}
    </span>
  );
};

export default Badge;
